import React from "react";
import Icon, { type IconComponent } from "@/icons/base";

const CloseIcon: IconComponent = ({ ...props }) => (
  <Icon {...props}>
    <path
      d="m3.28033009 2.21966991 4.71966991 4.71933009 4.7196699-4.71933009c.2928932-.29289321.767767-.29289321 1.0606602 0 .2928932.29289322.2928932.76776696 0 1.06066018l-4.7193301 4.71966991 4.7193301 4.7196699c.2928932.2928932.2928932.767767 0 1.0606602s-.767767.2928932-1.0606602 0l-4.7196699-4.7193301-4.71966991 4.7193301c-.29289322.2928932-.76776696.2928932-1.06066018 0-.29289321-.2928932-.29289321-.767767 0-1.0606602l4.71933009-4.7196699-4.71933009-4.71966991c-.29289321-.29289322-.29289321-.76776696 0-1.06066018.29289322-.29289321.76776696-.29289321 1.06066018 0z"
      fill="currentColor"
    />
  </Icon>
);

export default CloseIcon;
